// migrated to src_new/ui/core/page/Loading/Loading.tsx
import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Loading } from '@xingternal/winery-ui/lib/Loading';

const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${themeGet('zIndices.godLevel')};
`;

const PageLoading = () => (
  <LoadingWrapper>
    <Loading data-testid="loading-page" />
  </LoadingWrapper>
);

export { PageLoading };
